// extracted by mini-css-extract-plugin
module.exports = {"tableCol":"Share_tableCol__3c82D","tableTitle":"Share_tableTitle__1-Xhr","nameBox":"Share_nameBox__1Jsc8","btns":"Share_btns__3LeZV"};